import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { avantorAnimations } from '@core/animations/animations';
import { SITE_LINK } from '@core/constants';
import { TokenHolderService } from '@core/services/token-holder/token-holder-api';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { Component, ElementRef, EventEmitter, HostListener, Injector, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Overlay } from '@angular/cdk/overlay';
import { AvantorDialogsService } from '@shared/dialogs/avantor-dialogs-api';
import { MessageService } from '@core/services/message/message-api';
import { NewsService } from '@core/services/news/news-api';
import { UserService } from '@core/services/user/user-api';
import { OrgAndStockroomService } from '@core/services/org-and-stockroom/org-and-stockroom-api';
import { Notification } from '@shared/models/notification.model';
import { SearchService } from '@core/services/search/search-api';
import { HeaderBarService } from '@core/services/header-bar/header-bar-api';
import { PrivilegeService } from '@core/services/privilege/privilege-api';
import { NotificationsService } from '@core/services/notifications/notifications-api';
import { MediaObserver } from '@ngbracket/ngx-layout';
import { ToastService } from '@core/services/toast-api';
import { ComponentPortal } from '@angular/cdk/portal';
import { EnterprisePopupComponent } from './components/enterprise-popup/enterprise-popup';
import { ResponsiveMenuComponent } from './components/responsive-menu/responsive-menu';
import { NewsPanelComponent } from './components/news-panel/news-panel';
import { MessagesPanelComponent } from './components/messages-panel/messages-panel';
import { UserManualPanelComponent } from './components/user-manual-modal/user-manual-panel';
import { ChatService } from '@core/services/chat/chat-api';
import { MatDialog } from '@angular/material/dialog';
declare var moment: any;
import { takeUntil } from 'rxjs/operators';
import { getPrivileges, getStockroomOrgDetails, getUserConfig } from '@core/store/selectors/common.selectors';
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/reducers/common.reducer';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { BASE64_IMAGE, BASE_IMAGE1 } from '../../../../public/js/sinch_chat_image';
import { AnalyticsService } from '@core/services/analytics/analytics-api';
import { SoftwareService } from '@core/services/download-center/software/software-api';
import { AppService } from '@core/services/app/app-api';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '@shared/materials.module';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalDateTimePipePipe } from '@shared/pipes/global-date-time-pipe.pipe';
import { HEADER_DATA } from './header-data.token';
import { DialogSupportTicketFormComponent } from './components/support-ticket/dialog-support-ticket-form/dialog-support-ticket-form';
import { DialogNewUserCreationFormComponent } from './components/new-user-creation/dialog-new-user-creation-form/dialog-new-user-creation-form';
import { DialogNewStockroomRequestFormComponent } from './components/new-stockroom-request/dialog-new-stockroom-request/dialog-new-stockroom-request';
import { HighlightPipe } from './highlight/highlight.pipe';
declare var Chatlayer: any;
declare var cvc: any;
declare var liveagent: any;
declare var window: any;
type OrgStockroom = {
  organization: string;
  stockroom: string;
}
declare const clarity: any;

@Component({
  selector: 'avantor-header',
  templateUrl: './avantor-header.html',
  styleUrls: ['./avantor-header.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [avantorAnimations],
  standalone: true,
  providers: [DatePipe],
  imports: [
    CommonModule,
    FormsModule,
    MaterialsModule,
    TranslateModule,
    RouterModule,
    ResponsiveMenuComponent,
    NewsPanelComponent,
    MessagesPanelComponent,
    UserManualPanelComponent,
    GlobalDateTimePipePipe,
    HighlightPipe,
  ],
})
export class AvantorHeaderComponent implements OnInit, OnDestroy {
  businessDetails: any;
  privileges!: Array<any>;
  private manualUpdated: boolean = false;
  private stopSearch$ = new Subject<void>();
  readonly SITE_LINK = SITE_LINK;
  approvalCount = 0;
  messageCount = 0;
  notificationsCount = 0;
  messageAndNotificationsCount = 0;
  newsCount = 0;
  notifCount = 0;
  notifications: Notification[] = [];
  searchTextChanged = new Subject<string>();
  searchValue = '';
  orgAndStockroomSub!: Subscription;
  notificationSubscription!: Subscription;
  messagesSubscription!: Subscription;
  newsSubscription!: Subscription;
  searchSelect = "All";
  vwrSearchResult: Array<any> = [];
  orderSearchResult: Array<any> = [];
  userSearchResult: Array<any> = [];
  productSearchResult: Array<any> = [];
  vendorSearchResult: Array<any> = [];
  stockroomSearchResult: Array<any> = [];
  softwareSearchResult: Array<any> = [];
  userType: any = "";
  userPrivileges = {
    activities: {
      consumeStock: false,
      replenishStock: false,
      receiveStock: false,
      createBarcodes: false,
      approval: false,
      stockCorrection: false,
      scannerFile: false,
      returnStock: false,
      transferStock: false
    },
    overview: {
      requests: false,
      orders: false,
      reporting: false,
      articleLog: false,
      stockroomLog: false,
      trackOrder: false,
      products: false,
    },
    administration: {
      vendorMaintenance: false,
      reference: false,
      reasonCode: false,
      productMaintenance: false,
      userMaintenance: false,
      deptMaintenance: false,
      locationMaintenance: false,
      costCenter: false,
      copyMoveArticle: false,
      exportImportProduct: false,
      messageCenter: false,
      manageStockroom: false,
      integrationMaintenance: false,
      localizationMaint: false,
      archivePurge: false,
      exportImportStockroom: false,
      userRoleMaintenance: false,
    },
    downloadCenter: false
  };
  searchPriv = true;
  @Input() StockRoomCreated = true;
  showHeaderSearch = false;
  mediaSub!: Subscription;
  storeSub!: Subscription;
  configSub!: Subscription;
  device: any;
  notifInterval: number = 1000 * 60 * 5;
  isChatDisabled = false;
  keywordSubscription!: Subscription;
  widgetData: any = [];
  palmRunInterpretation: string = '';
  @Output() toggleUserData = new EventEmitter();
  isShowAdminConsole: boolean = false;
  isAdminConsole: string = 'No';
  isCountryAdminViewOnly: boolean = false;
  isEnableLanguageKeyFeature: boolean = false;
  isNewUserStockroomFeatureEnabled: boolean = environment.isNewUserStockroomFeatureEnabled;
  isSupportTicketReportEnabled: boolean = environment.isSupportTicketReportEnabled;
  envDetails = environment;
  private destroy$: Subject<void> = new Subject();
  newsResponseData: any;
  userManualId: any;
  constructor(
    private router: Router,
    private renderer: Renderer2,
    private chatservice: ChatService,
    private el: ElementRef<HTMLIFrameElement>,
    private overlay: Overlay,
    private avantorDialogs: AvantorDialogsService,
    private tokenHolderService: TokenHolderService,
    private messageService: MessageService,
    private newsService: NewsService,
    private notificationService: NotificationsService,
    private userService: UserService,
    private orgAndStockroomService: OrgAndStockroomService,
    private searchService: SearchService,
    private headerService: HeaderBarService,
    private privelegeService: PrivilegeService,
    public mediaObserver: MediaObserver,
    private toastService: ToastService,
    private chatSupportService: ChatService,
    private store: Store<AppState>,
    private dialogService: AvantorDialogsService,
    private route: ActivatedRoute,
    public datepipe: DatePipe,
    public activatedRoute: ActivatedRoute,
    private analyticsService: AnalyticsService,
    private softwareService: SoftwareService,
    private appService: AppService,
    private dialog: MatDialog
  ) {
    this.isAdminConsole = sessionStorage.getItem('isAdminConsole') || 'No';
  }

  ngOnInit(): void {
    this.initStore();
    this.isEnableLanguageKeyFeature = environment.isAPIEnabledFeature;
    this.isNewUserStockroomFeatureEnabled = environment.isNewUserStockroomFeatureEnabled;
    this.isSupportTicketReportEnabled = environment.isSupportTicketReportEnabled;

    if (this.StockRoomCreated) {
      this.initMenuActiveState();
      this.initMenuEventListener();
      this.initResponsiveness();

      if (this.isAdminConsole == 'No') {
        this.keywordSubscription = this.searchTextChanged.pipe(
          debounceTime(500),
          distinctUntilChanged()
        ).subscribe(search => {
          this.searchFilter(search);
        });

        this.initOrgStockroom();
        this.initPollingRequest(true);
        this.getMessagesCount();
        this.getNotificationsCount();
        this.intializeData();
        if (this.router.url == '/app') {
          this.intializeContents();
          this.checkNewsIsAvailble();
        }
        this.orgAndStockroomService.isAdminSelected.subscribe((status: any) => {
          if (status) {
            this.isAdminConsole = sessionStorage.getItem('isAdminConsole') || 'No';
          }
        })
      }
      this.userService.getJumpWidgets().then(data => {
        for (let key in data) {
          this.widgetData.push({ name: key, url: data[key] });
        }
        this.headerService.updateJumpWidget(this.widgetData);
      })

      this.notificationService.approvalNotificationCount$.subscribe(result => {
        this.approvalCount = result;
      });

      this.newsSubscription = this.newsService.getNewsCounts().subscribe(result => {
        this.newsCount = result;
        this.messageAndNotificationsCount = this.messageCount + this.notificationsCount + this.newsCount;
      })

      let observer = this.mediaObserver.asObservable();
      this.mediaSub = observer.subscribe((result: any) => {
        this.device = result[0].mqAlias;
      })
      const currentUser: any = this.userData;
      if (currentUser.userType === 'SUPER_USER') {
        this.isShowAdminConsole = true;
      } else if (currentUser.userType === 'COUNTRY_ADMIN') {
        this.isShowAdminConsole = true;
      }
    }
  }

  ngAfterViewInit() {
    if (this.isAdminConsole == 'No') {
      this.fetchgetBusinessStatus()
    }
    this.initStore();


  }

  openSupportTicket() {
    this.analyticsService.sendDetailsForClickEventTracking({
      ModuleName: 'Header',
      EventUniqueID: 'header_support_ticket_click',
      click_value: 'Support Ticket',
      download_format: ''
    });

    setTimeout(() => {
      (document.activeElement as HTMLElement | null)?.blur();
      this.dialog.open(DialogSupportTicketFormComponent, {
        width: '1100px',
        maxWidth: '95vw',
        maxHeight: '95vh',
        autoFocus: 'dialog',
        disableClose: true,
        panelClass: 'support-ticket-form-panel',
      });
    });

  }

  openNewUserCreation(): void {
    if (!this.isNewUserStockroomFeatureEnabled) {
      return;
    }

    this.analyticsService.sendDetailsForClickEventTracking({
      ModuleName: 'Header',
      EventUniqueID: 'header_new_user_creation_click',
      click_value: 'New User Creation',
      download_format: ''
    });

    this.dialog.open(DialogNewUserCreationFormComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '95vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'new-user-creation-form-panel',
    });
  }

  openNewStockroomRequest(): void {
    if (!this.isNewUserStockroomFeatureEnabled) {
      return;
    }

    this.analyticsService.sendDetailsForClickEventTracking({
      ModuleName: 'Header',
      EventUniqueID: 'header_new_stockroom_request_click',
      click_value: 'New Stockroom Request',
      download_format: ''
    });

    this.dialog.open(DialogNewStockroomRequestFormComponent, {
      width: '820px',
      maxWidth: '95vw',
      maxHeight: '95vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'new-stockroom-request-form-panel',
    });
  }


  fetchgetBusinessStatus() {
    this.chatservice.getBusinessStatus().subscribe((data: any) => {
      this.businessDetails = data;
      if (this.businessDetails.isShinChatEnable === 'YES') {
        let find = this.businessDetails.queue.find((item: any) => item.id === this.businessDetails.sinchBusinessId)
        if (find) {
          if (find.statistics.status === 'open') {
            this.initChatLayer();
          } else {
            this.isChatDisabled = true
          }
        }
      } else {
        this.isChatDisabled = true
      }
    }, error => {
      console.error('Error fetching data:', error);
    });
  }
  fetchgetagentStatus() {
    this.chatservice.getagentStatus().subscribe((data: any) => {
      let find = data.find((item: any) => item.id === this.businessDetails.sinchBusinessId)
    }, error => {
      console.error('Error fetching data:', error);
    });
  }



  initChatLayer(): void {
    // Load Chatlayer SDK script
    const sdkScript = document.createElement('script');
    sdkScript.type = 'text/javascript';
    sdkScript.src = '/js/sinch.js';
    sdkScript.async = false; // Load synchronously for simplicity
    sdkScript.onload = () => {
      // Initialize Chatlayer after SDK script is loaded
      this.loadSinchChatFormDetails();
    };
    document.body.appendChild(sdkScript);
  }


  onStartChat() {
    this.analyticsService.sendDetailsForClickEventTracking({
      ModuleName: 'Header',
      EventUniqueID: 'header_chat_support_click',
      click_value: 'Chat Support',
      download_format: ''
    })
    Chatlayer.open();
  }

  onmessageAndNotificationsCount() {
    this.analyticsService.sendDetailsForClickEventTracking({
      ModuleName: 'Header',
      EventUniqueID: 'header_communication_center_click',
      click_value: 'Communication Center Icon',
      download_format: ''
    })
  }

  private loadSinchChatFormDetails(): void {
    // Chatlayer configuration

    const customActions = [{
      id: "END_CHAT",
      image: BASE_IMAGE1
    }];
    const customTitle = "Digital Tech Support";
    const storageValue = sessionStorage.getItem("config");
    let parsedValue
    let orgName
    if (storageValue !== null) {
      parsedValue = JSON.parse(storageValue);
    }
    const sessionStorageData = sessionStorage.getItem("cStockroomAndOrg");
    if (sessionStorageData !== null) {
      orgName = JSON.parse(sessionStorageData).organization.orgName;
    }
    const prechatForm = {
      elements: [
        {
          type: 'image',
          url: BASE64_IMAGE,
          alignment: 'center',
          width: 150,
          height: 50

        },
        {
          type: 'text',
          text: 'By clicking “Start Chat” you agree that this conversation may be transcribed, used, stored, or accessed by our third-party service providers in accordance with our [Privacy Policy](https://www.avantorsciences.com/us/en/privacy-policy)',
          alignment: 'center',
        },
        {
          type: 'spacer',
          size: 'xs',
        },
        {
          id: 'firstName',
          type: 'input',
          label: 'First Name:',
          required: true,
          placeholder: 'Enter First Name',
          defaultValue: parsedValue.firstName ? parsedValue.firstName : ''
        },
        {
          id: 'lastName',
          type: 'input',
          label: 'Last Name:',
          required: true,
          placeholder: 'Enter Last Name',
          defaultValue: parsedValue.lastName ? parsedValue.lastName : ''
        },
        {
          id: 'email',
          type: 'input',
          label: 'Email:',
          required: true,
          placeholder: 'Enter Email',
          defaultValue: parsedValue.email ? parsedValue.email : ''
        },
        {
          id: 'businessPhone',
          type: 'input',
          label: 'Business Phone:',
          required: true,
          placeholder: 'Enter Business Phone',
          defaultValue: parsedValue.phoneNumber ? parsedValue.phoneNumber : ''
        },
        {
          id: 'organizationName',
          type: 'input',
          label: 'Organization Name:',
          required: false,
          placeholder: 'Enter Organization Name',
          defaultValue: orgName ? orgName : ''

        },
        {
          type: 'spacer',
          size: 'md',
        },
      ]
    };

    const def = '__session_id__.' + this.businessDetails.sinchChannelId;
    const localStorageKey = def;
    // Initialize Chatlayer
    window.Chatlayer.init({
      channelId: this.businessDetails.sinchChannelId,
      region: this.businessDetails.sinchRegion,
      title: `${customTitle}`,
      prechatForm: prechatForm,
      customActions: customActions,
    });

    // localStorage.removeItem(localStorageKey);

    window.Chatlayer.on("init", async () => {
      window.Chatlayer.setSessionData('queueId', this.businessDetails.sinchBusinessId); // ADD QUEUE ID  
      window.Chatlayer.setSessionData('PageURL', environment.redirectUri + '/app');  // PLS CHANGE THIS TO HANDLE PARAMETER
    });

    window.Chatlayer.on('widget:custom_action', async (id: any) => {
      if (id.id === "END_CHAT") {
        localStorage.removeItem(localStorageKey);
        window.Chatlayer.sendMessage("User ended chat");
      }
    });
    window.Chatlayer.on("widget:closed", (event: any) => {
      Chatlayer.sendMessage("User ended chat");
    });
  }

  applyStylesToIframe(iframe: any, styles: any) {
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    const styleElement = iframeDoc.createElement('style');
    styleElement.innerText = styles;
    iframeDoc.head.appendChild(styleElement);
  }


  initStore() {
    this.storeSub = this.store.select(getPrivileges).subscribe((privileges: any) => {
      this.initUserPriveleges(privileges);
    })

    this.configSub = this.store.select(getUserConfig).subscribe((res: any) => {
      this.userData = res;
      if (this.userData) {
        this.userType = this.userData.userType;
        if (typeof clarity === 'function') {
          clarity('set', 'userId', this.userData.email);
        }
        this.isCountryAdminViewOnly = this.userData.isViewCountryAdmin;
      }
    })

    this.orgAndStockroomSub = this.store.select(getStockroomOrgDetails).subscribe((res: any) => {
      if (res && res?.organization) {
        const data = res;
        this.currentOrgStockroom = data;
        this.palmRunInterpretation = data?.organization?.palmRunInterpretation
        this.replenishModel = data?.organization?.replenishModel;
        if (sessionStorage.getItem('isAdminConsole') !== 'Yes') {
          this.orgAndStockroomService.setStockroomAndOrgName(JSON.stringify(res));
        }
      }
    })
  }

  /**
   * [DPIM-5043] - Unread message and notification count in the  header
   * 
   * fetches message count from backend and updates the count in chat widget
   */
  getMessagesCount() {
    this.messagesSubscription = this.messageService.getMessageCounts().subscribe((res: any) => {
      this.messageCount = res;

      this.messageAndNotificationsCount = this.messageCount + this.notificationsCount + this.newsCount;
    });
  }

  /**
  * [DPIM-5043] - Unread message and notification count in header
  * 
  * fetches notification count from backend and updates the count in chat widget
  */
  getNotificationsCount() {
    this.notificationSubscription = this.notificationService.getNotificationCounts().subscribe(result => {
      this.notificationsCount = result;
      this.messageAndNotificationsCount = this.messageCount + this.notificationsCount + this.newsCount;
    })
  }


  navigateToHome() {
    if (this.isAdminConsole == 'Yes') {
      this.router.navigate(['app/admin/organization/organization-maintenance']);
    } else {
      this.router.navigate(['/app']);
    }
  }

  naivgateToAdminConosleOrgView() {
    let currentOrgStockroom = this.orgAndStockroomService.getStockroomAndOrg();
    if (currentOrgStockroom) {
      const data = JSON.parse(currentOrgStockroom);
      this.router.navigate(['app/admin/organization/organization-maintenance/manage-organization/required-settings-normal'], { queryParams: { mode: 'view', id: data.orgId } });
    }
  }

  accountSetting() {
    this.analyticsService.sendDetailsForClickEventTracking({
      ModuleName: 'Account Setting',
      EventUniqueID: 'account_setting_click',
      click_value: 'Acoount Setting',
      download_format: ''
    })
  }

  /**--------------------------------------
   * @USER_DATA
   * Initialize user data
   */
  // public userData?: User;
  public userData?: any;


  /**--------------------------------------
   * @DIALOG_CHANGE_STOCKROOM
   * Header dialog for changing of stockroom
   */
  dialogChangeOrganizationStockroom() {
    this.avantorDialogs.openDialogChangeOrganizationOrStockroom();
  }


  /**--------------------------------------
   * @HEADER_ACTIVE_TABS
   * Customized active state of header navigations
   */
  public activeStateObservable = new Subscription();
  public activeExpandingMenu!: string;

  initMenuActiveState() {
    this.initActivateMenu();

    this.activeStateObservable = this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.initActivateMenu();
        return;
      }
    });
  }
  initActivateMenu() {
    let menuCategory = this.router.url.split("/")[2] == 'admin' ? this.router.url.split("/")[3] : this.router.url.split("/")[2];
    this.activeExpandingMenu = menuCategory;
  }


  /**--------------------------------------
 * @GLOBAL_SEARCH
 * Overlay panel for global search
 */
  isGlobalSearchPanelOpen: boolean = false;

  openGlobalSearch() {
    this.isGlobalSearchPanelOpen = true;
  }
  closeGlobalSearch() {
    this.isGlobalSearchPanelOpen = false;
  }

  /**--------------------------------------
   * @SIDEBAR_PANELS
   * Overlay panel toggle for:
   * News Panel,
   * Messages Panel
   */
  cdkScrollStrategy = this.overlay.scrollStrategies.block();

  isNewsPanelOpen: boolean = false;
  isNewsPanelAnimate: boolean = false;

  isUserPanelOpen: boolean = false;
  isUserPanelAnimate: boolean = false;

  toggleNewsPanel(status: boolean) {
    if (status) {
      this.isNewsPanelOpen = status;
      this.isNewsPanelAnimate = status;
    } else {
      this.isNewsPanelAnimate = status;
      setTimeout(() => {
        this.isNewsPanelOpen = status;
      }, 250);
    }
  }
  toggleUserPanelV2(status: boolean) {
    if (status) {
      this.isUserPanelOpen = status;
      this.isUserPanelAnimate = status;
    } else {
      this.isUserPanelAnimate = status;
      setTimeout(() => {
        this.isUserPanelOpen = status;
      }, 250);
    }
  }

  isMessagesPanelOpen: boolean = false;
  isMessagesPanelAnimate: boolean = false;

  toggleMessagePanel(status: boolean) {
    if (status) {
      this.isMessagesPanelOpen = status;
      this.isMessagesPanelAnimate = status;
    } else {
      this.isMessagesPanelAnimate = status;
      setTimeout(() => {
        this.isMessagesPanelOpen = status;
      }, 250);
    }
  }

  isResponsiveMenuOpen: boolean = false;
  isResponsiveMenuAnimate: boolean = false;

  toggleResponsiveMenu(status: boolean) {
    if (status) {
      this.isResponsiveMenuOpen = status;
      this.isResponsiveMenuAnimate = status;
    } else {
      this.isResponsiveMenuAnimate = status;
      setTimeout(() => {
        this.isResponsiveMenuOpen = status;
      }, 250);
    }
  }


  /**--------------------------------------
   * @RESPONSIVE_MENU
   * Responsive UI triggers
   */
  public smallScreen: boolean = false;

  public topOffset: number = 0;
  public leftOffset: number = 0;

  @HostListener('window:resize', ['$event'])
  initResponsiveness() {
    let outerWidth = window.innerWidth;

    //Always toggle off header search when resized
    this.showHeaderSearch = false;

    if (outerWidth < 1366) {

      this.smallScreen = true;


    } else {
      this.toggleResponsiveMenu(false);
      this.smallScreen = false;
      this.topOffset = 0;
      this.leftOffset = 0;
    }
  }

  onToggleData(data: string) {
    if (data == 'user') {
      this.toggleUserPanelV2(true);
    }
  }


  /**--------------------------------------
   * @HEADER_MENU_NAVIGATIONS
   * Mega menu navigations customized
   * using material tabs
   */
  public menuOpen: boolean = false;
  public menuBtnClick: boolean = false;
  public selectedTab: number = 0;
  public routeObservable = new Subscription();

  initMenuEventListener() {
    //Listen to outside click event to auto close menu
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.menuBtnClick) {
        this.selectedTab = 0;
      }
      this.menuBtnClick = false;
    });
    //Hides menu if it's open upon route change
    this.routeObservable = this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.toggleMenu(0);
      }
    });
  }
  toggleMenu(tabIndex: number) {
    if (tabIndex === 1) {
      this.getApprovalCount();
    }
    if (tabIndex === this.selectedTab) {
      this.selectedTab = 0;
      this.menuOpen = true;
    } else {
      this.selectedTab = tabIndex;
      this.menuOpen = true;
    }

  }
  preventCloseOnClick() {
    this.menuBtnClick = true;
    localStorage.setItem("userTabIindex", "0");
  }


  /**--------------------------------------
   * @LOGOUT
   * User menu logout
   */
  logout() {
    this.userTrackingLogout();
  }


  /**--------------------------------------
   * @CURRENT_ORG_STOCKROOM
   */
  public currentOrgStockroom!: OrgStockroom;
  public replenishModel?: string;

  initOrgStockroom() {
    const currentOrgStockroom = this.orgAndStockroomService.getStockroomAndOrgName();
    if (currentOrgStockroom) {
      const data = JSON.parse(currentOrgStockroom);
      this.currentOrgStockroom = data;
      this.palmRunInterpretation = data?.organization?.palmRunInterpretation
      this.replenishModel = data?.organization?.replenishModel;
    }
  }

  counter: any;
  intializeData() {
    this.counter = setInterval(async () => {
      if (this.router.url.toLowerCase().includes('app') && this.isAdminConsole == 'No') {
        this.initPollingRequest();
      }
    }, this.notifInterval)
  }

  async initPollingRequest(from_init = false) {
    await this.messageService.getMessageCount();
    await this.newsService.getNewsCount();
    // getNotificationCount api call is needed for showing notification count in chat widget in header [DPIM-5043]
    await this.notificationService.getNotificationsCount();

  }

  async getNotifications() {
    this.analyticsService.sendDetailsForClickEventTracking({
      ModuleName: 'Header',
      EventUniqueID: 'header_notification_bell_click',
      click_value: 'Notification Bell Icon',
      download_format: ''
    })
    this.notifications = [];
    await this.userService.getNotifications().then(notifs => {
      let notifications = notifs.data;
      this.notifications = notifications.map((element: any) => {
        if (element.markedAsRead == false && element.id) {
          return {
            ...element,
            createdDateNew: this.datepipe.transform(element.createdDate, 'MM/DD/yyyy'),
            createdTimeNew: this.datepipe.transform(element.createdDate, 'LT'),
            parsedSubject: this.htmlParser(element),
            isHtmlContent: this.isHTML(element.body)
          }
        }
      })
    }).catch(error => console.log(error));
  }

  isHTML(str: any) {
    var doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  }

  htmlParser(data: any) {
    let parser = new DOMParser();
    const doc = parser.parseFromString(data.body, 'text/html');
    return doc.getElementById('Text5')?.outerHTML;

  }

  clearSearchResults() {
    this.vwrSearchResult = [];
    this.vendorSearchResult = [];
    this.orderSearchResult = [];
    this.userSearchResult = [];
    this.productSearchResult = [];
    this.softwareSearchResult = [];
  }

  async searchFilter(keyword: string) {
    this.headerSearch(this.searchSelect, keyword);
  }

  async headerSearch(type: string, keyword: string): Promise<any> {
    this.clearSearchResults();
    this.stopSearch$.next();
    if (type == 'All' && keyword.length > 2) {
      this.searchService.searchAll(keyword).pipe(takeUntil(this.stopSearch$)).subscribe((result: any) => {
        if (this.searchValue) {
          this.vwrSearchResult = result.gwList?.prodList ? result.gwList.prodList : [];
          this.vendorSearchResult = result.vendorList.data;
          this.orderSearchResult = result.orderList.data;
          this.userSearchResult = result.userList.data;
          this.productSearchResult = result.productList.data;
          this.softwareSearchResult = result.downloadCenterList.data;
        } else {
          this.clearSearchResults();
        }
      }, err => {
        this.clearSearchResults();
      });
    }

    if (type === 'vwr' && keyword.length > 2) {
      let search = keyword;

      (this.searchService.searchVWR(search, 0, 5)).pipe(takeUntil(this.stopSearch$)).subscribe((result: any) => {
        if (search) {
          this.vwrSearchResult = result.prodList ?? [];
        } else {
          this.vwrSearchResult = [];
        }
      });
    }

    if (type === 'vendors' && keyword.length > 2) {
      this.searchService.searchVendors(keyword, 0, 5).subscribe((result: any) => {
        this.vendorSearchResult = keyword ? result.data : []
      });
    }

    if (type === 'orders' && keyword.length > 2) {
      this.searchService.searchOrders(keyword, 0, 5).subscribe((result: any) => {
        this.orderSearchResult = keyword ? result.data : []
      });
    }

    if (type === 'users' && keyword.length > 2) {
      this.searchService.searchUsers(keyword, 0, 5).subscribe((result: any) => {
        this.userSearchResult = keyword ? result.data : []
      });
    }

    if (type === 'products' && keyword.length > 2) {
      this.searchService.searchProducts(keyword, 0, 5).subscribe((result: any) => {
        this.productSearchResult = keyword ? result.data : []
      });
    }

    if (type === 'download' && keyword.length > 2) {
      this.searchService.searchSoftware(keyword, 0, 5).subscribe((result: any) => {
        this.softwareSearchResult = keyword ? result.data : []
      });
    }

  }
  search(event: any) {
    this.searchValue = event?.target?.value ?? '';
    this.searchTextChanged.next(this.searchValue);
  }

  navigateToPage(type: string, item: any) {
    if (type === 'users') {
      this.router.navigate(['app/administration/user-maintenance/view/' + item.id]);
    }
    else if (type === 'stockrooms') {
      this.router.navigate(['app/administration/manage-stockroom/' + item.id]);
    }
    this.closeGlobalSearch()
  }

  approvalCounter: any;
  getApprovalCount() {
    this.notificationService.requestApprovalCount();
  }


  initUserPriveleges(privileges: any) {
    this.privileges = this.privelegeService.getPrivilege();
    if (!this.privelegeService.findPrivelege('priv_general_search', privileges) && !this.privelegeService.findChildPrivelege('general:search', privileges)) {
      this.searchPriv = false;
    } else {
      this.searchPriv = true;
    }
    this.userPrivileges.activities.consumeStock = this.privelegeService.findPrivelege('priv_consume_stock_icon', privileges) ? true : false;
    this.userPrivileges.activities.replenishStock = this.privelegeService.findPrivelege('priv_replenish_stock_icon', privileges) ? true : false;
    this.userPrivileges.activities.receiveStock = this.privelegeService.findPrivelege('priv_receive_stock_icon', privileges) ? true : false;
    this.userPrivileges.activities.createBarcodes = this.privelegeService.findPrivelege('priv_create_barcode_icon', privileges) ? true : false;
    this.userPrivileges.activities.approval = this.privelegeService.findPrivelege('priv_approval_icon', privileges) ? true : false;
    this.userPrivileges.activities.stockCorrection = this.privelegeService.findPrivelege('priv_administer_stock_icon', privileges) ? true : false;
    this.userPrivileges.activities.scannerFile = this.privelegeService.findPrivelege('priv_palm_run_report_icon', privileges) ? true : false;
    this.userPrivileges.activities.returnStock = this.privelegeService.findPrivelege('priv_return_stock_icon', privileges) ? true : false;
    this.userPrivileges.activities.transferStock = this.privelegeService.findPrivelege('priv_setup_copyandmove_articles_icon', privileges) && this.privelegeService.findChildPrivelege('priv_move_articles', privileges) ? true : false;

    this.userPrivileges.overview.requests = this.privelegeService.findPrivelege('priv_overview_icon', privileges) ? true : false;
    this.userPrivileges.overview.orders = this.privelegeService.findPrivelege('priv_overview_icon', privileges) ? true : false;
    this.userPrivileges.overview.reporting = this.privelegeService.findPrivelege('priv_overview_report_icon', privileges) ? true : false;
    this.userPrivileges.overview.articleLog = this.privelegeService.findPrivelege('priv_overview_activitylog_icon', privileges) ? true : false;
    this.userPrivileges.overview.stockroomLog = this.privelegeService.findPrivelege('priv_overview_activitylog_icon', privileges) ? true : false;
    this.userPrivileges.overview.trackOrder = this.privelegeService.findPrivelege('priv_order_tracking_icon', privileges) ? true : false;
    this.userPrivileges.overview.products = this.privelegeService.findPrivelege('priv_overview_icon', privileges) ? true : false;


    this.userPrivileges.administration.vendorMaintenance = this.privelegeService.findPrivelege('priv_setup_vendor_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.reference = this.privelegeService.findPrivelege('priv_setup_reference_code_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.reasonCode = this.privelegeService.findPrivelege('priv_setup_reason_code_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.productMaintenance = this.privelegeService.findPrivelege('priv_setup_product_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.userMaintenance = this.privelegeService.findPrivelege('priv_setup_user_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.deptMaintenance = this.privelegeService.findPrivelege('priv_setup_department_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.locationMaintenance = this.privelegeService.findPrivelege('priv_setup_location_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.costCenter = this.privelegeService.findPrivelege('priv_setup_cost_center_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.copyMoveArticle = this.privelegeService.findPrivelege('priv_setup_copyandmove_articles_icon', privileges) ? true : false;
    this.userPrivileges.administration.exportImportProduct = this.privelegeService.findPrivelege('priv_setup_import_export_stockroom_icon', privileges) ? true : false;
    this.userPrivileges.administration.messageCenter = this.privelegeService.findPrivelege('priv_setup_message_center_icon', privileges) ? true : false;
    this.userPrivileges.administration.manageStockroom = this.privelegeService.findPrivelege('priv_setup_manage_stockroom_icon', privileges) ? true : false;
    this.userPrivileges.administration.integrationMaintenance = this.privelegeService.findPrivelege('priv_setup_integrations_icon', privileges) ? true : false;
    this.userPrivileges.administration.localizationMaint = this.privelegeService.findPrivelege('priv_setup_localization_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.administration.archivePurge = this.privelegeService.findPrivelege('priv_setup_archive_purge', privileges) ? true : false;
    this.userPrivileges.administration.exportImportStockroom = this.privelegeService.findPrivelege('priv_setup_import_export_stock_icon', privileges) ? true : false;
    this.userPrivileges.administration.userRoleMaintenance = this.privelegeService.findPrivelege('priv_setup_role_maintenance_icon', privileges) ? true : false;
    this.userPrivileges.downloadCenter = this.privelegeService.findPrivelege('priv_download_softwares_icon', privileges) ? true : this.privelegeService.findPrivelege('priv_download_documents_icon', privileges) ? true : false;


  }

  toggleSearchDropdown() {
    this.showHeaderSearch = !this.showHeaderSearch;
  }

  palmRunOnHand(model: string) {
    if (model == 'ON_HAND_MODEL') {
      this.analyticsEvent('Scanner Replenish On Hand ', '/app/activities/scanner-replenish/on-hand')
      this.router.navigate(['/app/activities/scanner-replenish/on-hand']);
    } else if (model == 'PUTAWAY_MODEL') {
      this.analyticsEvent('Scanner Replenish Putaway ', '/app/activities/scanner-replenish/put-away')
      this.router.navigate(['/app/activities/scanner-replenish/put-away']);
    }
    else {
      this.palmRunOnHand(this.palmRunInterpretation === 'PUT_AWAY' ? 'PUTAWAY_MODEL' : 'ON_HAND_MODEL')
    }
  }

  navigateToSearchResults(event: any) {

    if (this.searchValue == '') {
      this.toastService.show('error', 'Please enter any keyword.', '', false, 5000);
      return;
    }

    if (this.searchSelect === "All") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.PRODUCTS]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    } else if (this.searchSelect == "products") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.PRODUCTS]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    } else if (this.searchSelect == "orders") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.ORDERS]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    } else if (this.searchSelect == "vendors") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.VENDORS]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    } else if (this.searchSelect == "users") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.USERS]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    } else if (this.searchSelect == "vwr") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.VWR]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    } else if (this.searchSelect == "download") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.DOWNLOAD_CENTER]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    }
  }

  setSearchValue(keyword: any, category: string) {
    this.searchValue = keyword;

    if (category === "All") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.PRODUCTS]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    } else if (category == "products") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.PRODUCTS]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    } else if (category == "orders") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.ORDERS]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    } else if (category == "vendors") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.VENDORS]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    } else if (category == "users") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.USERS]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    } else if (category == "vwr") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.VWR]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    } else if (category == "download") {
      this.router.navigate([SITE_LINK.SEARCH_RESULT.DOWNLOAD_CENTER]);
      this.searchService.setKeyword(this.searchValue);
      this.closeGlobalSearch();
    }
  }

  formatName(user: any) {
    return `${user.firstName} ${user.lastName}`
  }



  /**-----------------------------------------
   * @ENTERPRISE_POPOVER
   */
  openEnterpriseDialog() {
    this.avantorDialogs.openEnterpriseDialog();
  }

  overlayInstance!: any

  onHover(connectedTo: any) {
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo(connectedTo)
      .withPositions([{
        originX: 'end',
        originY: 'center',
        overlayX: 'start',
        overlayY: 'center',
      }, {
        originX: 'start',
        originY: 'center',
        overlayX: 'end',
        overlayY: 'center',
      }]);

    const overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy
    });

    // Create ComponentPortal that can be attached to a PortalHost
    const filePreviewPortal = new ComponentPortal(EnterprisePopupComponent, null, this.createInjector(connectedTo));

    // Attach ComponentPortal to PortalHost
    this.overlayInstance = overlayRef.attach(filePreviewPortal);
    this.overlayInstance.instance.closePanel.subscribe(() => {
      overlayRef.dispose();
      overlayRef.detach();
    });

  }

  createInjector(data: any) {
    return Injector.create({
      providers: [{ provide: HEADER_DATA, useValue: data }],
    });
  }

  toggleUserPanel(value: boolean) {
    this.analyticsService.sendDetailsForClickEventTracking({
      ModuleName: 'Header',
      EventUniqueID: 'header_user_manual_click',
      click_value: 'User Manual',
      download_format: ''
    })
    this.toggleUserData.emit(value);
    this.orgAndStockroomService.isShowPdfViewer = true;
    if (!this.manualUpdated) {
      this.orgAndStockroomService.updatemanual(true);
      this.manualUpdated = true;
    }
  }

  startTour() {
    this.analyticsService.sendDetailsForClickEventTracking({
      ModuleName: 'Header',
      EventUniqueID: 'header_guided_tour_click',
      click_value: 'Guided Tour',
      download_format: ''
    })
    this.dialogService.openWelcomeTourDialog();
  }

  getUserManaulaId() {
    this.softwareService.getUserManual('IM Enterprise Manual').subscribe({
      next: (res: any) => {
        this.userManualId = res?.data;
        this.appService.getUpdatedUserManualId(this.userManualId);
      },
      error: (error: any) => {
        if (error?.status === 401) {
          this.userManualId = null;
        }
      }
    })
  }

  ngOnDestroy() {
    if (this.StockRoomCreated || this.isAdminConsole != '') {
      this.routeObservable.unsubscribe();
      this.activeStateObservable.unsubscribe();
      this.keywordSubscription?.unsubscribe();
      this.notificationSubscription?.unsubscribe();
      this.messagesSubscription?.unsubscribe();
      clearInterval(this.counter);
      clearInterval(this.approvalCounter)
      this.storeSub.unsubscribe();
      this.orgAndStockroomSub.unsubscribe();

    }
  }

  intializeContents() {
    this.newsService.getNews(0, -1, 'createdDate:desc', '');
  }
  checkNewsIsAvailble() {

    let isNewsAvailable: any;
    let isNewsPanelBlocked: any = sessionStorage.getItem('isNewsPanelBlocked');
    this.newsService.getNew().subscribe({
      next: (result) => {
        this.newsResponseData = result?.data;
        isNewsAvailable = result?.data && result.data.some((element: any) => element.statusString === 'unread');
        if ((isNewsAvailable && this.router.url == '/app') && !isNewsPanelBlocked) {
          this.toggleNewsPanel(true);
        }
      },
      error: (err) => {
        console.error('Failed to fetch news:', err);
        // Optionally handle the error case, e.g., show a user-friendly message
      }
    });
  }

  openNewsPanel() {
    this.analyticsService.sendDetailsForClickEventTracking({
      ModuleName: 'Header',
      EventUniqueID: 'header_news_update_click',
      click_value: 'News & Updates',
      download_format: ''
    })
    this.intializeContents();
    this.toggleNewsPanel(true)
  }

  openFAQs() {
    this.router.navigate(['/app', SITE_LINK.FREQUENTLY_ASKED_QUESTIONS.BASE]);
  }

  analyticsEvent(moduleName: any, route: any) {
    this.analyticsService.sendDetailsForClickEventTracking({
      event: "im_menu_click",
      ModuleName: moduleName,
      link_click: route,
    })
  }

  userTrackingLogout() {
    const userTrackingInfo = JSON.parse(sessionStorage.getItem('userTrackingInfo') || '{}');
    this.orgAndStockroomService.auditLogout().then((data: any) => {
      if (userTrackingInfo) {
        sessionStorage.removeItem('userTrackingInfo');
      }
      this.clearDatas();
    }).catch(err => {
      this.clearDatas();
      console.log(err);
      // throw err;
    });
  }

  clearDatas() {
    clearInterval(this.counter);
    localStorage.removeItem('LocalcurrentDepartFieldName');
    localStorage.removeItem('itemsOnList');
    localStorage.removeItem('renderingBatchEnableProducts');
    localStorage.removeItem('renderingDifferentSectionAccountSettings');
    this.tokenHolderService.logoutSession();
    let state: any = null;
    sessionStorage.removeItem('isNewsPanelOpend');
    sessionStorage.removeItem('isNewsPanelBlocked');
  }


}
